import { LampsIcon } from './LampsIcon';

/**
 * author: Michael Irigoyen
 * id 9AC5919E-2271-42D0-A5FA-ACB9BE022547
 * name lamps
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lamps.svg
 * tags
 * - Home Automation 
 */
export const LightsIcon = LampsIcon;
export default LightsIcon